import React from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";

const borderColor = "#bff0fd";
const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    borderBottomColor: "#bff0fd",
    backgroundColor: "#E2F6Fa",
    borderBottomWidth: 1,
    alignItems: "center",
    height: 24,
    textAlign: "center",
    fontStyle: "bold",
    flexGrow: 1,
  },
  title: {
    width: "80%",
    borderRightColor: borderColor,
    borderRightWidth: 1,
    textAlign: "left",
    paddingLeft: 8,
  },

  rate: {
    width: "20%",
    borderRightColor: borderColor,
    borderRightWidth: 1,
  },
});

const ProductHeader = () => (
  <View style={styles.container}>
    <Text style={styles.title}>Item</Text>
    <Text style={styles.rate}>Quantity</Text>
  </View>
);

export default ProductHeader;
